// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Title_titleWrapper__pGJ2e","center":"Title_center__2Nd-j"};